import { SharedModule } from './../../../share/shared.module';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AppService } from '../../../app.service';
import { LayoutService } from '../layout.service';
import { RolesDirective } from '../../../directives/app.roles.directives';

@Component({
  selector: 'app-layout-sidenav',
  imports: [SharedModule, RouterModule, RolesDirective],
  templateUrl: './layout-sidenav.component.html',
  styleUrl: './layout-sidenav.component.scss'
})
export class LayoutSidenavComponent {

  constructor(
    private router: Router,
    private appService: AppService,
    private layoutService: LayoutService
  ){}

  isActive(url: string) {
    return this.router.isActive(url, true);
  }

  isWide(): boolean {
    return this.layoutService.sidenavIsWide();
  }

  toggleWide() {
    this.layoutService.sidenavSetWide(!this.layoutService.sidenavIsWide());
  }

}
